import {STATUS_JSON_ingester} from './feed-json-ingester';

export class FeedJsoningesterFilters {
  status: STATUS_JSON_ingester;
  documentId : string;
  start: Date;
  end: Date;
  day : Date;
}
